// utils/showOnHoldAlert.tsx
import React, { ReactNode } from "react";
import { RBButton } from "../components/RBButton";


// export interface AlertInfo {
//   title: string;
//   message: ReactNode;
//   buttons: ReactNode[];
// }

// export interface AlertState {
//   isAlertShowing: boolean;
//   alertInfo: AlertInfo | null;
// }

interface ShowOnHoldAlertParams {
  setAlertState:any;
  primaryColor: string;
  contactEmail: string;
  page?:any;
  navigation?: any;
}


export const showOnHoldAlert = ({
  setAlertState,
  primaryColor,
  contactEmail,
  page,
  navigation
}: ShowOnHoldAlertParams): void => {
  setAlertState({
    isAlertShowing: true,
    alertInfo: {
      title: "",
      message: (
        <>
          <br />
          Sorry, it appears your account is on hold. Please connect with{" "}
          <b>
            {localStorage.getItem("networkName")} {contactEmail}
          </b>{" "}
          for more details.
        </>
      ),
      buttons: [
        <RBButton
          key="confirm"
          onClick={() => {
            setAlertState({ isAlertShowing: false, alertInfo: null });
            if(page === 'dashboard')
            {
              navigation.push("/dashboard");
            }
          }}
          buttonBackgroundColor={primaryColor}
          color="primary"
          text="Ok"
        />,
      ],
    },
  });
};
